import React, { useEffect } from "react";
import MyButton1 from "./CustomComponents/MyButton1";
import {
  CssBaseline,
  IconButton,
  Typography,
} from "@mui/material";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ConfirmDialog } from "primereact/confirmdialog";

import "./eventComponent/EventTabs/EventTabs.css";
import { homePagePath } from "../constant";
import Navbar from "../redesign/components/Navbar";
import Footer from "../redesign/components/Footer";

export const Terms_Conditions = () => {
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  const backtoHome = () => {
    navigate(isLoggedIn ? "/dashboard" : homePagePath);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <CssBaseline />
      <Navbar />


      <div className={`main-container ${!isLoggedIn ? "no-auth" : ""}`}>
        <div className="event-service-head-inner-policy">
          {/* <IconButton
                  onClick={backtoHome}
                  style={{
                    backgroundColor: "#0cc0df",
                    color: "#fff",
                    padding: "8px",
                  }}
                >
                  <KeyboardBackspaceOutlinedIcon />
                </IconButton> */}
          <div>
            <button
              className="back-to-services-btn"
              onClick={backtoHome}
            >
              <i className='pi pi-arrow-left'></i> Back to Dashboard
            </button>

          </div>


        </div>
        <div className="center-heading">
          <h1>Terms & Conditions</h1>
        </div>
        <div className="frontend-container">
          <div className="event-form-inner">
            <div className="event-form-body alter full">
              <div className="event-form-content">

                <p>
                  For the purpose of these Terms and Conditions, The term "we", "us", "our" used anywhere on this page shall mean
                  THURENT TECH SERVICES PRIVATE LIMITED, whose registered/operational office is 6-1/5 Chaitanya, Vidyut Nagar Dilsukhnagar
                  Colony K.V.Rangareddy Saroornagar Telangana 500060 P and T Colony (Gaddiannaram) TELANGANA 500060 . "you", "your", "user",
                  "visitor" shall mean any natural or legal person who is visiting our website and/or agreed to purchase from us.
                </p>
                <p>Your use of the website and/or purchase from us are governed by following Terms and Conditions:</p>
                <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
                  <li>
                    The content of the pages of this website is subject to change without notice.
                  </li>
                  <li>
                    Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness, or suitability of the information and materials found or offered on this website for any particular purpose. You acknowledge that such information and materials may contain inaccuracies or errors, and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law.
                  </li>
                  <li>
                    Your use of any information or materials on our website and/or product pages is entirely at your own risk, for which we shall not be liable. It shall be your own responsibility to ensure that any products, services, or information available through our website and/or product pages meet your specific requirements.
                  </li>
                  <li>
                    Our website contains material which is owned by or licensed to us. This material includes, but is not limited to, the design, layout, look, appearance, and graphics. Reproduction is prohibited other than in accordance with the copyright notice, which forms part of these terms and conditions.
                  </li>
                  <li>
                    All trademarks reproduced on our website which are not the property of, or licensed to, the operator are acknowledged on the website.
                  </li>
                  <li>
                    Unauthorized use of information provided by us shall give rise to a claim for damages and/or be a criminal offense.
                  </li>
                  <li>
                    From time to time, our website may also include links to other websites. These links are provided for your convenience to provide further information.
                  </li>
                  <li>
                    You may not create a link to our website from another website or document without THURENT TECH SERVICES PRIVATE LIMITED's prior written consent.
                  </li>
                  <li>
                    Any dispute arising out of the use of our website and/or purchase with us and/or any engagement with us is subject to the laws of India.
                  </li>
                  <li>
                    We shall be under no liability whatsoever in respect of any loss or damage arising directly or indirectly out of the decline of authorization for any transaction, on account of the cardholder having exceeded the preset limit mutually agreed by us with our acquiring bank from time to time.
                  </li>
                </ul>
                <div className="terms_conditions-info-container">
                  <p>
                    Registered Office: 6-1/5, Chaitanya, Vidyut Nagar Dilsukhnagar Colony, Saroornagar RANGAREDDY- 500060, TELANGANA INDIAEmail: nick@thurent.com

                  </p>
                  <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",       // Ensure full width
                    padding: "0 20px"    // Optional: Add horizontal padding
                  }}>
                    <p style={{ margin: 0 }}>Email: nick@thurent.com</p>
                    <p style={{ margin: 0 }}>Phone: 74167 34499</p>
                    <p style={{ margin: 0 }}>Website: www.thurent.com</p>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <ConfirmDialog />
    </div>
  );
};

export default Terms_Conditions;
